// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"77751a5b","856":"3550a88f","952":"3b751e80"}[chunkId] + ".chunk.js";
};